import { render, staticRenderFns } from "./ResellerProducts.vue?vue&type=template&id=02b5e62e&scoped=true"
import script from "./ResellerProducts.vue?vue&type=script&lang=js"
export * from "./ResellerProducts.vue?vue&type=script&lang=js"
import style0 from "./ResellerProducts.vue?vue&type=style&index=0&id=02b5e62e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b5e62e",
  null
  
)

export default component.exports